// /* eslint-disable consistent-return */
// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   forwardRef,
//   useImperativeHandle,
// } from 'react';
// import { useLocation } from 'react-router-dom';
// import { MdLink, MdLinkOff, MdDelete, MdClose } from 'react-icons/md';
// import { RiAddBoxFill } from 'react-icons/ri';
// import Checkbox from '@mui/material/Checkbox';
// import PropTypes from 'prop-types';

// import history from '../../../services/history';

// import { EditButton, LinkButton } from './Actions';
// import ModalExcluirItens from './ModalExcluir';

// import {
//   Table,
//   HeaderOptions,
//   TableRow,
//   Wrapper,
//   CheckCell,
//   CheckHeader,
//   BarraExclusao,
// } from './styles';

// /** chave estável de um item da página (a PK é idItem + idMaterial) */
// const chaveItem = (item) => `${item.idItem}|${item.idMaterial}`;

// const TableEditor = forwardRef(
//   (
//     {
//       idCatalogo,
//       idPagina,
//       itensPagina,
//       isDraggable,
//       onLinkHighlight,
//       onGoToLink,
//       onSelectPending,
//       onExcluirItens,
//     },
//     ref
//   ) => {
//     const location = useLocation();

//     const [table, setTable] = useState([]);

//     /**
//      * ===================================================================
//      * MODO DE EXCLUSÃO EM LOTE
//      * -------------------------------------------------------------------
//      * Fluxo: lixeira no cabeçalho -> aparece o checkbox à esquerda de cada
//      * item e a barra de confirmação -> o botão da barra abre o diálogo que
//      * exige digitar EXCLUIR -> só então a exclusão é enviada.
//      *
//      * O modo fica desligado por padrão para a coluna continuar idêntica ao
//      * que é hoje em uso normal.
//      * ===================================================================
//      */
//     const [modoExclusao, setModoExclusao] = useState(false);
//     const [chavesExclusao, setChavesExclusao] = useState([]);
//     const [confirmacaoAberta, setConfirmacaoAberta] = useState(false);
//     const [excluindo, setExcluindo] = useState(false);

//     useEffect(() => {
//       if (itensPagina) {
//         setTable(
//           itensPagina.map((item) => ({
//             ...item,
//             ...item.materialFabricante,
//           }))
//           // .sort((a, b) => a.ordena - b.ordena)
//         );
//       }
//     }, [itensPagina]);

//     /** define a propriedade de destaque do item de acordo com o estado fornecido */
//     const handleHighlight = useCallback((id, state) => {
//       setTable((old) =>
//         old.map((item) =>
//           item.idItem === id
//             ? { ...item, highlighted: item.locked || state }
//             : item
//         )
//       );
//     }, []);

//     const handleLock = useCallback((id, state) => {
//       setTable((old) =>
//         old.map((item) =>
//           item.idItem === id
//             ? {
//                 ...item,
//                 highlighted: state || item.highlighted,
//                 locked: state,
//               }
//             : item
//         )
//       );
//     }, []);

//     useImperativeHandle(ref, () => ({
//       getLockStates: () =>
//         table.map(
//           (item) =>
//             ({
//               idItem: item.idItem,
//               locked: item.locked,
//             } || null)
//         ),

//       highlightLinks: (links) => {
//         setTable((old) =>
//           old.map((item) => {
//             if (item.linked && (links.includes(item.idItem) || item.locked)) {
//               item.highlighted = true;
//             } else {
//               item.highlighted = false;
//             }
//             return item;
//           })
//         );
//       },
//     }));

//     const handleDraggable = useCallback(
//       (e) => {
//         const row = table.find((i) => String(i.idItem) === String(e.target.id));
//         e.dataTransfer.setData('text/row-list', JSON.stringify(row));
//       },
//       [table]
//     );

//     const handleAdicionarItem = useCallback(() => {
//       history.push('/catalogo/itens/criar', {
//         background: location,
//         idCatalogo,
//         idPagina,
//       });
//     }, [idCatalogo, idPagina, location]);

//     /** itens efetivamente marcados, na ordem em que aparecem na tabela */
//     const itensSelecionados = table.filter((item) =>
//       chavesExclusao.includes(chaveItem(item))
//     );

//     /** quantos dos marcados já possuem link desenhado na página */
//     const selecionadosComLink = itensSelecionados.filter((item) => item.linked)
//       .length;

//     const todosMarcados =
//       table.length > 0 && itensSelecionados.length === table.length;

//     /** sai do modo e limpa a seleção */
//     const handleSairExclusao = useCallback(() => {
//       setModoExclusao(false);
//       setChavesExclusao([]);
//       setConfirmacaoAberta(false);
//     }, []);

//     /**
//      * Mantém a seleção coerente com o que está na tela.
//      *
//      * A lista muda ao trocar de página e ao filtrar pela pesquisa. Marcar
//      * um item e depois escondê-lo pelo filtro deixaria uma seleção
//      * invisível: ela não apareceria na confirmação, mas seria excluída.
//      * Por isso toda chave que não está mais na lista é descartada.
//      */
//     useEffect(() => {
//       setChavesExclusao((atual) =>
//         atual.filter((chave) => table.some((item) => chaveItem(item) === chave))
//       );
//       setConfirmacaoAberta(false);
//     }, [table]);

//     const handleAlternarModoExclusao = useCallback(() => {
//       setModoExclusao((atual) => {
//         if (atual) {
//           setChavesExclusao([]);
//           setConfirmacaoAberta(false);
//         }
//         return !atual;
//       });
//     }, []);

//     const handleAlternarItem = useCallback((item) => {
//       const chave = chaveItem(item);

//       setChavesExclusao((atual) =>
//         atual.includes(chave)
//           ? atual.filter((c) => c !== chave)
//           : [...atual, chave]
//       );
//     }, []);

//     const handleAlternarTodos = useCallback(() => {
//       setChavesExclusao((atual) =>
//         atual.length === table.length ? [] : table.map(chaveItem)
//       );
//     }, [table]);

//     /**
//      * Envia a exclusão.
//      *
//      * A guarda de lista vazia é obrigatória: o endpoint em lote apaga
//      * TODOS os itens da página quando recebe "itens" vazio.
//      */
//     const handleConfirmarExclusao = useCallback(async () => {
//       if (!onExcluirItens || itensSelecionados.length === 0) return;

//       setExcluindo(true);
//       try {
//         const ok = await onExcluirItens(
//           itensSelecionados.map((item) => ({
//             idPagina,
//             idItem: item.idItem,
//             idMaterial: item.idMaterial,
//           }))
//         );

//         if (ok) handleSairExclusao();
//       } finally {
//         setExcluindo(false);
//       }
//     }, [onExcluirItens, itensSelecionados, idPagina, handleSairExclusao]);

//     const handleLockHighlight = useCallback(
//       (id) => {
//         const link = table.find((_item) => _item.idItem === id);
//         if (link) handleLock(id, !link.locked);
//       },
//       [table, handleLock]
//     );

//     const handleHoverHighlight = useCallback(
//       (id) => {
//         const link = table.find((_item) => _item.idItem === id);
//         if (link) handleHighlight(id, !link.highlighted);
//       },
//       [table, handleHighlight]
//     );

//     useEffect(() => {
//       const highlightedItems = table
//         .filter((item) => item.linked && (item.highlighted || item.locked))
//         .map((item) => item.idItem);

//       onLinkHighlight(highlightedItems, 'table');
//     }, [table, onLinkHighlight]);

//     return (
//       <>
//         <Wrapper>
//           {/**
//            * Barra do modo de exclusão. Só aparece com o modo ligado e
//            * acompanha a rolagem da lista (position: sticky).
//            */}
//           {modoExclusao && (
//             <BarraExclusao>
//               <strong>
//                 {itensSelecionados.length === 0
//                   ? 'Marque os itens que deseja excluir'
//                   : `${itensSelecionados.length} de ${
//                       table.length
//                     } selecionado${itensSelecionados.length === 1 ? '' : 's'}`}
//               </strong>
//               <div>
//                 <button type="button" onClick={handleSairExclusao}>
//                   <MdClose size={14} />
//                   Cancelar
//                 </button>
//                 <button
//                   type="button"
//                   className="perigo"
//                   disabled={itensSelecionados.length === 0}
//                   title={
//                     itensSelecionados.length === 0
//                       ? 'Selecione ao menos um item'
//                       : 'Confirmar a exclusão dos itens marcados'
//                   }
//                   onClick={() => setConfirmacaoAberta(true)}
//                 >
//                   <MdDelete size={14} />
//                   Excluir selecionados
//                 </button>
//               </div>
//             </BarraExclusao>
//           )}

//           <Table>
//             <thead>
//               <tr>
//                 {modoExclusao && (
//                   <CheckHeader>
//                     <Checkbox
//                       size="small"
//                       color="error"
//                       sx={{ padding: 0 }}
//                       title="Marcar/desmarcar todos"
//                       checked={todosMarcados}
//                       indeterminate={
//                         itensSelecionados.length > 0 && !todosMarcados
//                       }
//                       onChange={handleAlternarTodos}
//                     />
//                   </CheckHeader>
//                 )}
//                 {onLinkHighlight && <th>Link</th>}
//                 <th>Item</th>
//                 <th>Código</th>
//                 <HeaderOptions>
//                   <div>
//                     <button
//                       type="button"
//                       title="Adicionar item"
//                       onClick={handleAdicionarItem}
//                     >
//                       <RiAddBoxFill size={22} />
//                     </button>
//                     {/**
//                      * Lixeira: liga o modo de seleção múltipla. Só é
//                      * exibida quando a tela informa um manipulador de
//                      * exclusão (perfil com permissão).
//                      */}
//                     {onExcluirItens && (
//                       <button
//                         type="button"
//                         aria-pressed={modoExclusao}
//                         title={
//                           modoExclusao
//                             ? 'Sair do modo de exclusão'
//                             : 'Excluir itens: marque vários e confirme'
//                         }
//                         onClick={handleAlternarModoExclusao}
//                       >
//                         <MdDelete size={20} />
//                       </button>
//                     )}
//                   </div>
//                 </HeaderOptions>
//               </tr>
//             </thead>
//             <tbody>
//               {table.map((item, index) => (
//                 <TableRow
//                   key={index}
//                   id={item.idItem}
//                   /**
//                    * No modo de exclusão o arraste é desligado: arrastar a
//                    * linha para o desenho enquanto se marca itens para
//                    * apagar é ambíguo e atrapalha o clique no checkbox.
//                    */
//                   draggable={isDraggable && !modoExclusao}
//                   linked={item.linked}
//                   highlighted={item.highlighted || item.locked}
//                   onDragStart={handleDraggable}
//                   onMouseEnter={(e) => {
//                     if (
//                       item.linked &&
//                       e.target.matches(':hover') &&
//                       !item.highlighted
//                     )
//                       handleHoverHighlight(item.idItem);
//                   }}
//                   onMouseLeave={(e) => {
//                     if (
//                       item.linked &&
//                       !e.target.matches(':hover') &&
//                       item.highlighted
//                     )
//                       handleHoverHighlight(item.idItem);
//                   }}
//                 >
//                   {modoExclusao && (
//                     <CheckCell>
//                       <Checkbox
//                         size="small"
//                         color="error"
//                         sx={{ padding: 0 }}
//                         checked={chavesExclusao.includes(chaveItem(item))}
//                         onChange={() => handleAlternarItem(item)}
//                         inputProps={{
//                           'aria-label': `Selecionar o item ${item.idItem}`,
//                         }}
//                       />
//                     </CheckCell>
//                   )}
//                   {onLinkHighlight && (
//                     <td>
//                       {item.linked && (
//                         <LinkButton
//                           title="Fixar destaque e ir para o link no desenho"
//                           handleItem={() => {
//                             handleLockHighlight(item.idItem);
//                             /** leva o desenho até o link deste item */
//                             if (onGoToLink) onGoToLink(item.idItem);
//                           }}
//                         >
//                           <MdLink className="linkSvg" size={20} />
//                         </LinkButton>
//                       )}
//                       {/**
//                        * Item ainda sem link: define-o como alvo do modo
//                        * sequência, para o próximo arraste no desenho.
//                        */}
//                       {!item.linked && onSelectPending && (
//                         <LinkButton
//                           title="Mapear este item agora (modo sequência)"
//                           handleItem={() => onSelectPending(item)}
//                         >
//                           <MdLinkOff className="linkSvg" size={20} />
//                         </LinkButton>
//                       )}
//                     </td>
//                   )}
//                   <td>{item.idItem}</td>
//                   <td>{item.partnumber}</td>
//                   <td>
//                     <EditButton
//                       idCatalogo={idCatalogo}
//                       idPagina={idPagina}
//                       item={item}
//                     />
//                   </td>
//                 </TableRow>
//               ))}
//             </tbody>
//           </Table>
//         </Wrapper>

//         {confirmacaoAberta && (
//           <ModalExcluirItens
//             itens={itensSelecionados}
//             comLink={selecionadosComLink}
//             excluindo={excluindo}
//             onCancel={() => setConfirmacaoAberta(false)}
//             onConfirm={handleConfirmarExclusao}
//           />
//         )}
//       </>
//     );
//   }
// );

// export default TableEditor;

// TableEditor.propTypes = {
//   idCatalogo: PropTypes.number.isRequired,
//   idPagina: PropTypes.number.isRequired,
//   itensPagina: PropTypes.instanceOf(Object).isRequired,
//   isDraggable: PropTypes.bool,
//   onLinkHighlight: PropTypes.func,
//   onGoToLink: PropTypes.func,
//   onSelectPending: PropTypes.func,
//   /**
//    * Recebe a lista de itens marcados e devolve true quando a exclusão foi
//    * concluída. Quando não é informado, a lixeira não aparece — é assim
//    * que o perfil sem permissão fica sem o recurso.
//    */
//   onExcluirItens: PropTypes.func,
// };

// TableEditor.defaultProps = {
//   isDraggable: false,
//   onLinkHighlight: () => {},
//   onGoToLink: null,
//   onSelectPending: null,
//   onExcluirItens: null,
// };

/* eslint-disable consistent-return */
import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { useLocation } from 'react-router-dom';
import { MdLink, MdLinkOff, MdDelete, MdClose } from 'react-icons/md';
import { RiAddBoxFill } from 'react-icons/ri';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';

import history from '../../../services/history';

import { EditButton, LinkButton } from './Actions';
import ModalExcluirItens from './ModalExcluir';

import {
  Table,
  HeaderOptions,
  TableRow,
  Wrapper,
  CheckCell,
  CheckHeader,
  BarraExclusao,
} from './styles';

/** chave estável de um item da página (a PK é idItem + idMaterial) */
const chaveItem = (item) => `${item.idItem}|${item.idMaterial}`;

const TableEditor = forwardRef(
  (
    {
      idCatalogo,
      idPagina,
      itensPagina,
      isDraggable,
      onLinkHighlight,
      onGoToLink,
      onSelectPending,
      onExcluirItens,
      /**
       * A tabela preenche a altura do pai em vez de usar o teto fixo de
       * 900px. Só faz sentido quando o pai tem altura definida — hoje
       * apenas a tela de Mapeamento (ver Table/styles.js).
       */
      alturaTotal,
    },
    ref
  ) => {
    const location = useLocation();

    const [table, setTable] = useState([]);

    /**
     * ===================================================================
     * MODO DE EXCLUSÃO EM LOTE
     * -------------------------------------------------------------------
     * Fluxo: lixeira no cabeçalho -> aparece o checkbox à esquerda de cada
     * item e a barra de confirmação -> o botão da barra abre o diálogo que
     * exige digitar EXCLUIR -> só então a exclusão é enviada.
     *
     * O modo fica desligado por padrão para a coluna continuar idêntica ao
     * que é hoje em uso normal.
     * ===================================================================
     */
    const [modoExclusao, setModoExclusao] = useState(false);
    const [chavesExclusao, setChavesExclusao] = useState([]);
    const [confirmacaoAberta, setConfirmacaoAberta] = useState(false);
    const [excluindo, setExcluindo] = useState(false);

    useEffect(() => {
      if (itensPagina) {
        setTable(
          itensPagina.map((item) => ({
            ...item,
            ...item.materialFabricante,
          }))
          // .sort((a, b) => a.ordena - b.ordena)
        );
      }
    }, [itensPagina]);

    /** define a propriedade de destaque do item de acordo com o estado fornecido */
    const handleHighlight = useCallback((id, state) => {
      setTable((old) =>
        old.map((item) =>
          item.idItem === id
            ? { ...item, highlighted: item.locked || state }
            : item
        )
      );
    }, []);

    const handleLock = useCallback((id, state) => {
      setTable((old) =>
        old.map((item) =>
          item.idItem === id
            ? {
                ...item,
                highlighted: state || item.highlighted,
                locked: state,
              }
            : item
        )
      );
    }, []);

    useImperativeHandle(ref, () => ({
      getLockStates: () =>
        table.map(
          (item) =>
            ({
              idItem: item.idItem,
              locked: item.locked,
            } || null)
        ),

      highlightLinks: (links) => {
        setTable((old) =>
          old.map((item) => {
            if (item.linked && (links.includes(item.idItem) || item.locked)) {
              item.highlighted = true;
            } else {
              item.highlighted = false;
            }
            return item;
          })
        );
      },
    }));

    const handleDraggable = useCallback(
      (e) => {
        const row = table.find((i) => String(i.idItem) === String(e.target.id));
        e.dataTransfer.setData('text/row-list', JSON.stringify(row));
      },
      [table]
    );

    const handleAdicionarItem = useCallback(() => {
      history.push('/catalogo/itens/criar', {
        background: location,
        idCatalogo,
        idPagina,
      });
    }, [idCatalogo, idPagina, location]);

    /** itens efetivamente marcados, na ordem em que aparecem na tabela */
    const itensSelecionados = table.filter((item) =>
      chavesExclusao.includes(chaveItem(item))
    );

    /** quantos dos marcados já possuem link desenhado na página */
    const selecionadosComLink = itensSelecionados.filter((item) => item.linked)
      .length;

    const todosMarcados =
      table.length > 0 && itensSelecionados.length === table.length;

    /** sai do modo e limpa a seleção */
    const handleSairExclusao = useCallback(() => {
      setModoExclusao(false);
      setChavesExclusao([]);
      setConfirmacaoAberta(false);
    }, []);

    /**
     * Mantém a seleção coerente com o que está na tela.
     *
     * A lista muda ao trocar de página e ao filtrar pela pesquisa. Marcar
     * um item e depois escondê-lo pelo filtro deixaria uma seleção
     * invisível: ela não apareceria na confirmação, mas seria excluída.
     * Por isso toda chave que não está mais na lista é descartada.
     */
    useEffect(() => {
      setChavesExclusao((atual) =>
        atual.filter((chave) => table.some((item) => chaveItem(item) === chave))
      );
      setConfirmacaoAberta(false);
    }, [table]);

    const handleAlternarModoExclusao = useCallback(() => {
      setModoExclusao((atual) => {
        if (atual) {
          setChavesExclusao([]);
          setConfirmacaoAberta(false);
        }
        return !atual;
      });
    }, []);

    const handleAlternarItem = useCallback((item) => {
      const chave = chaveItem(item);

      setChavesExclusao((atual) =>
        atual.includes(chave)
          ? atual.filter((c) => c !== chave)
          : [...atual, chave]
      );
    }, []);

    const handleAlternarTodos = useCallback(() => {
      setChavesExclusao((atual) =>
        atual.length === table.length ? [] : table.map(chaveItem)
      );
    }, [table]);

    /**
     * Envia a exclusão.
     *
     * A guarda de lista vazia é obrigatória: o endpoint em lote apaga
     * TODOS os itens da página quando recebe "itens" vazio.
     */
    const handleConfirmarExclusao = useCallback(async () => {
      if (!onExcluirItens || itensSelecionados.length === 0) return;

      setExcluindo(true);
      try {
        const ok = await onExcluirItens(
          itensSelecionados.map((item) => ({
            idPagina,
            idItem: item.idItem,
            idMaterial: item.idMaterial,
          }))
        );

        if (ok) handleSairExclusao();
      } finally {
        setExcluindo(false);
      }
    }, [onExcluirItens, itensSelecionados, idPagina, handleSairExclusao]);

    const handleLockHighlight = useCallback(
      (id) => {
        const link = table.find((_item) => _item.idItem === id);
        if (link) handleLock(id, !link.locked);
      },
      [table, handleLock]
    );

    const handleHoverHighlight = useCallback(
      (id) => {
        const link = table.find((_item) => _item.idItem === id);
        if (link) handleHighlight(id, !link.highlighted);
      },
      [table, handleHighlight]
    );

    useEffect(() => {
      const highlightedItems = table
        .filter((item) => item.linked && (item.highlighted || item.locked))
        .map((item) => item.idItem);

      onLinkHighlight(highlightedItems, 'table');
    }, [table, onLinkHighlight]);

    return (
      <>
        <Wrapper alturaTotal={alturaTotal}>
          {/**
           * Barra do modo de exclusão. Só aparece com o modo ligado e
           * acompanha a rolagem da lista (position: sticky).
           */}
          {modoExclusao && (
            <BarraExclusao>
              <strong>
                {itensSelecionados.length === 0
                  ? 'Marque os itens que deseja excluir'
                  : `${itensSelecionados.length} de ${
                      table.length
                    } selecionado${itensSelecionados.length === 1 ? '' : 's'}`}
              </strong>
              <div>
                <button type="button" onClick={handleSairExclusao}>
                  <MdClose size={14} />
                  Cancelar
                </button>
                <button
                  type="button"
                  className="perigo"
                  disabled={itensSelecionados.length === 0}
                  title={
                    itensSelecionados.length === 0
                      ? 'Selecione ao menos um item'
                      : 'Confirmar a exclusão dos itens marcados'
                  }
                  onClick={() => setConfirmacaoAberta(true)}
                >
                  <MdDelete size={14} />
                  Excluir selecionados
                </button>
              </div>
            </BarraExclusao>
          )}

          <Table>
            <thead>
              <tr>
                {modoExclusao && (
                  <CheckHeader>
                    <Checkbox
                      size="small"
                      color="error"
                      sx={{ padding: 0 }}
                      title="Marcar/desmarcar todos"
                      checked={todosMarcados}
                      indeterminate={
                        itensSelecionados.length > 0 && !todosMarcados
                      }
                      onChange={handleAlternarTodos}
                    />
                  </CheckHeader>
                )}
                {onLinkHighlight && <th>Link</th>}
                <th>Item</th>
                <th>Código</th>
                <HeaderOptions>
                  <div>
                    <button
                      type="button"
                      title="Adicionar item"
                      onClick={handleAdicionarItem}
                    >
                      <RiAddBoxFill size={22} />
                    </button>
                    {/**
                     * Lixeira: liga o modo de seleção múltipla. Só é
                     * exibida quando a tela informa um manipulador de
                     * exclusão (perfil com permissão).
                     */}
                    {onExcluirItens && (
                      <button
                        type="button"
                        aria-pressed={modoExclusao}
                        title={
                          modoExclusao
                            ? 'Sair do modo de exclusão'
                            : 'Excluir itens: marque vários e confirme'
                        }
                        onClick={handleAlternarModoExclusao}
                      >
                        <MdDelete size={20} />
                      </button>
                    )}
                  </div>
                </HeaderOptions>
              </tr>
            </thead>
            <tbody>
              {table.map((item, index) => (
                <TableRow
                  key={index}
                  id={item.idItem}
                  /**
                   * No modo de exclusão o arraste é desligado: arrastar a
                   * linha para o desenho enquanto se marca itens para
                   * apagar é ambíguo e atrapalha o clique no checkbox.
                   */
                  draggable={isDraggable && !modoExclusao}
                  linked={item.linked}
                  highlighted={item.highlighted || item.locked}
                  onDragStart={handleDraggable}
                  onMouseEnter={(e) => {
                    if (
                      item.linked &&
                      e.target.matches(':hover') &&
                      !item.highlighted
                    )
                      handleHoverHighlight(item.idItem);
                  }}
                  onMouseLeave={(e) => {
                    if (
                      item.linked &&
                      !e.target.matches(':hover') &&
                      item.highlighted
                    )
                      handleHoverHighlight(item.idItem);
                  }}
                >
                  {modoExclusao && (
                    <CheckCell>
                      <Checkbox
                        size="small"
                        color="error"
                        sx={{ padding: 0 }}
                        checked={chavesExclusao.includes(chaveItem(item))}
                        onChange={() => handleAlternarItem(item)}
                        inputProps={{
                          'aria-label': `Selecionar o item ${item.idItem}`,
                        }}
                      />
                    </CheckCell>
                  )}
                  {onLinkHighlight && (
                    <td>
                      {item.linked && (
                        <LinkButton
                          title="Fixar destaque e ir para o link no desenho"
                          handleItem={() => {
                            handleLockHighlight(item.idItem);
                            /** leva o desenho até o link deste item */
                            if (onGoToLink) onGoToLink(item.idItem);
                          }}
                        >
                          <MdLink className="linkSvg" size={20} />
                        </LinkButton>
                      )}
                      {/**
                       * Item ainda sem link: define-o como alvo do modo
                       * sequência, para o próximo arraste no desenho.
                       */}
                      {!item.linked && onSelectPending && (
                        <LinkButton
                          title="Mapear este item agora (modo sequência)"
                          handleItem={() => onSelectPending(item)}
                        >
                          <MdLinkOff className="linkSvg" size={20} />
                        </LinkButton>
                      )}
                    </td>
                  )}
                  <td>{item.idItem}</td>
                  <td>{item.partnumber}</td>
                  <td>
                    <EditButton
                      idCatalogo={idCatalogo}
                      idPagina={idPagina}
                      item={item}
                    />
                  </td>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </Wrapper>

        {confirmacaoAberta && (
          <ModalExcluirItens
            itens={itensSelecionados}
            comLink={selecionadosComLink}
            excluindo={excluindo}
            onCancel={() => setConfirmacaoAberta(false)}
            onConfirm={handleConfirmarExclusao}
          />
        )}
      </>
    );
  }
);

export default TableEditor;

TableEditor.propTypes = {
  idCatalogo: PropTypes.number.isRequired,
  idPagina: PropTypes.number.isRequired,
  itensPagina: PropTypes.instanceOf(Object).isRequired,
  isDraggable: PropTypes.bool,
  onLinkHighlight: PropTypes.func,
  onGoToLink: PropTypes.func,
  onSelectPending: PropTypes.func,
  /**
   * Recebe a lista de itens marcados e devolve true quando a exclusão foi
   * concluída. Quando não é informado, a lixeira não aparece — é assim
   * que o perfil sem permissão fica sem o recurso.
   */
  onExcluirItens: PropTypes.func,
  alturaTotal: PropTypes.bool,
};

TableEditor.defaultProps = {
  isDraggable: false,
  onLinkHighlight: () => {},
  onGoToLink: null,
  onSelectPending: null,
  onExcluirItens: null,
  alturaTotal: false,
};
